// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const cherrim: PokeData = {
  "id": 421,
  "name": "cherrim",
  "height": 5,
  "weight": 93,
  "base_experience": 158,
  "types": [
    PokeType.GRASS
  ],
  "api_moves": [
    "tackle",
    "take-down",
    "double-edge",
    "absorb",
    "leech-seed",
    "growth",
    "solar-beam",
    "stun-spore",
    "sleep-powder",
    "petal-dance",
    "morning-sun",
    "sunny-day",
    "helping-hand",
    "magical-leaf",
    "lucky-chant",
    "worry-seed",
    "energy-ball",
    "petal-blizzard",
    "draining-kiss",
    "flower-shield",
    "leafage"
  ],
  "moves": [
    "tackle",
    "solar-beam",
    "stun-spore",
    "morning-sun",
    "sunny-day",
    "energy-ball",
    "frenzy-plant",
    "flower-rush",
    "aromatherapy",
    "branch-poke",
    "razor-leaf",
    "vine-whip",
    "bullet-seed"
  ],
  "evolution_chain": {
    "id": 217,
    "item": null,
    "species": [
      {
        "name": "cherubi",
        "order": 448,
        "types": [
          PokeType.GRASS
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "cherrim",
        "order": 449,
        "types": [
          PokeType.GRASS
        ],
        "evolves_from_species_id": 420,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 25,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 118,
    "speed": 139,
    "ability_power": 143
  },
  "stat_changes": [],
  "catch_rate": 75,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
